const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveMediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
};

export const isVideoUrl = (url) => {
  if (!url) return false;
  return /\.(mp4|mov|avi|webm|wmv|mpeg|flv|3gp)/i.test(url);
};
